import { Lock, Unlock } from 'lucide-react';
import React from 'react';
import { IconButton, FormDrawer } from '../../ui';
import FormBlockDeblockService from '../Forms/FormBlockDeblockService';

export default function BlockDeblockService(props: { handleFunction: any, service: any }) {
    const [open, setOpen] = React.useState(false);
    const isActive = props.service.Statut == 1;

    return (
        <div>
            <IconButton onClick={() => setOpen(true)} color={isActive ? 'success' : "danger"} size={32} tooltip={isActive ? 'Bloquer' : "Débloquer"}>
                {isActive ? <Unlock size={16} /> : <Lock size={16} />}
            </IconButton>
            <FormDrawer
                open={open}
                onClose={() => setOpen(false)}
                title={`${isActive ? 'Blocage' : "Déblocage"} du service`}
                hint={isActive
                    ? "Attention : le blocage rendra ce service inaccessible."
                    : "Le déblocage réactivera ce service."}
            >
                <FormBlockDeblockService handleFunction={() => { setOpen(false); props.handleFunction() }} service={props.service} />
            </FormDrawer>
        </div>
    );
}
